module.exports = __webpack_public_path__ + "static/5-0a17d7677319ba7214d6eaa90fddb3b1.jpg";